import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Phpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csswitch(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  const right = {
    padding: '0 0 0 '+padding+'rem',
  };
return(
      <div>
      <Sides/>
      
      <Helmet>
 
 <title>Learn Free PHP Switch Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="Php Switch tutorial for beginners Switch in Php is a collection of similar type of data and stored in manually consecutively under one name." />
 <meta name="keywords" content="codeexampler,php switch case or,php switch case example,php switch multiple case,programming language tutorial for begineers,Php Switch,php switch statement,php switch default,Php Switch for loop,end for loop Php,Php foreach Switch" />
 <link rel="canonical" href="https://www.codeexampler.com/php-switch" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">Php Switch</h1>
    <div className="first">
        <a href="/php-if-else-if">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-looping-statement">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">Switch statement in Php</h2>
<p className="mt-4 para">That is used in multiple conditions with different statements like-if if, but it can check only equality of the floating condition point, but the switch can’t check value.</p>



<h2 className="headings">Syntax for Switch Statement in Php:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-4">Switch</span>
            <span className="qwerty-2"> (</span>
            <span className="qwerty-1">expression</span>
            <span className="qwerty-2">)</span>
            {"\n"}
            <span className="qwerty-3">&#123;</span>
              {"\n"} 
            <span className="qwerty">Case </span>
            <span className="qwerty-7">condition </span>
            <span className="qwerty-4">1</span>
            <span className="qwerty-3">:</span>
              {"\n"}
              <span className="qwerty-6"> statement</span>
            <span className="qwerty-2"> (</span>
            <span className="qwerty-4">s</span>
            <span className="qwerty-2">)</span>
              {"\n"} 
              <span className="qwerty-10">  Break</span>
              <span className="qwerty-4">;</span>
              {"\n"} 
            <span className="qwerty">Case </span>
            <span className="qwerty-7">condition </span>
            <span className="qwerty-4">2</span>
            <span className="qwerty-3">:</span>
              {"\n"}
              <span className="qwerty-6"> statement</span>
            <span className="qwerty-2"> (</span>
            <span className="qwerty-4">s</span>
            <span className="qwerty-2">)</span>
              {"\n"} 
              <span className="qwerty-10">  Break</span>
              <span className="qwerty-4">;</span>
              {"\n"}  
            <span className="qwerty">Case </span>
            <span className="qwerty-7">condition </span>
            <span className="qwerty-4">3</span>
            <span className="qwerty-3">:</span>
              {"\n"}
              <span className="qwerty-6"> statement</span>
            <span className="qwerty-2"> (</span>
            <span className="qwerty-4">s</span>
            <span className="qwerty-2">)</span>
              {"\n"} 
              <span className="qwerty-10">  Break</span>
              <span className="qwerty-4">;</span>
              {"\n"} 
              <span className="qwerty-3"> Default </span>
              <span className="qwerty-4">:</span>
              {"\n"} 
              <span className="qwerty-6"> statement</span>
            <span className="qwerty-2"> (</span>
            <span className="qwerty-4">s</span>
            <span className="qwerty-2">)</span>
              {"\n"} 
              <span className="qwerty-3">&#125;</span>
              {"\n"}  {"\n"}
              <span className="qwerty-2"> OR</span>
              {"\n"}  {"\n"}
              <span className="qwerty-4">Switch</span>
            <span className="qwerty-2"> (</span>
            <span className="qwerty-9">expression</span>
            <span className="qwerty-2">)</span>
            {"\n"}
            <span className="qwerty">Case </span>
            <span className="qwerty-7">condition </span>
            <span className="qwerty-4">1</span>
            <span className="qwerty-3">:</span>
              {"\n"}
              <span className="qwerty-6"> statement</span>
            <span className="qwerty-2"> (</span>
            <span className="qwerty-4">s</span>
            <span className="qwerty-2">)</span>
              {"\n"} 
              <span className="qwerty-10">  Break</span>
              <span className="qwerty-4">;</span>
              {"\n"} 
            <span className="qwerty">Case </span>
            <span className="qwerty-7">condition </span>
            <span className="qwerty-4">2</span>
            <span className="qwerty-3">:</span>
              {"\n"}
              <span className="qwerty-6"> statement</span>
            <span className="qwerty-2"> (</span>
            <span className="qwerty-4">s</span>
            <span className="qwerty-2">)</span>
              {"\n"} 
              <span className="qwerty-10">  Break</span>
              <span className="qwerty-4">;</span>
              {"\n"}  
            <span className="qwerty">Case </span>
            <span className="qwerty-7">condition </span>
            <span className="qwerty-4">3</span>
            <span className="qwerty-3">:</span>
              {"\n"}
              <span className="qwerty-6"> statement</span>
            <span className="qwerty-2"> (</span>
            <span className="qwerty-4">s</span>
            <span className="qwerty-2">)</span>
              {"\n"} 
              <span className="qwerty-10">  Break</span>
              <span className="qwerty-4">;</span>
              {"\n"} 
              <span className="qwerty-3"> Default </span>
              <span className="qwerty-4">:</span>
              {"\n"} 
              <span className="qwerty-6"> statement</span>
            <span className="qwerty-2"> (</span>
            <span className="qwerty-4">s</span>
            <span className="qwerty-2">)</span>
            {"\n"} 
              <span className="qwerty-10">Endswitch</span>
            <span className="qwerty-4">;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>  


<p className="mt-4 para">In this keyword switch inside c programming  that will yield an integer value, forex-case1,case2, etc. this is an integer constant<br/>
if you do not find any match with any of these cases statements so on that time default statement Execute
</p>


<p className="mt-4 para">This program gives output but not what we expected because we did not provide the production of case 3 and the default value
Switch switch statement:<br/>
so if you want to provide the only case 2 statement so using switch Switch Php means switch case Switch Php statement and Learn <a href="https://www.codeexampler.com/php-function">PHP Function</a>
</p>

<h2 className="mt-4 mh2">Php switch statement Examples:</h2>



<h3 className="headings">Q-Write a program to input a no and print month name and if no is Two in Switch Php?</h3>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-4">&#60;</span>
            <span className="qwerty-2">?</span>
            <span className="qwerty-6">php</span>
            {"\n"}
            <span className="qwerty">$</span>
            <span className="qwerty-7">month </span>
            <span className="qwerty-4">=</span>
            <span className="qwerty-3"> 4</span>
            <span className="qwerty-3">;</span>
              {"\n"}
              <span className="qwerty-6"> Switch</span>
            <span className="qwerty-2"> (</span>
              <span className="qwerty">$</span>
            <span className="qwerty-7">month</span>
            <span className="qwerty-2">)</span>
              {"\n"}
            <span className="qwerty-3">&#123;</span>
              {"\n"} 
            <span className="qwerty">Case </span>
            <span className="qwerty-4">1</span>
            <span className="qwerty-3">:</span>
              {"\n"}
              <span className="qwerty-6"> echo</span>
            <span className="qwerty-2"> "</span>
            <span className="qwerty-4">Jan</span>
            <span className="qwerty-2">";</span>
              {"\n"} 
              <span className="qwerty-10">  Break</span>
              <span className="qwerty-4">;</span>
              {"\n"} 
            <span className="qwerty">Case </span>
            <span className="qwerty-4">2</span>
            <span className="qwerty-3">:</span>
              {"\n"}
              <span className="qwerty-6"> echo</span>
            <span className="qwerty-2"> "</span>
            <span className="qwerty-4">Feb</span>
            <span className="qwerty-2">";</span>
              {"\n"} 
              <span className="qwerty-10">  Break</span>
              <span className="qwerty-4">;</span>
              {"\n"}  
            <span className="qwerty">Case </span>
            <span className="qwerty-4">3</span>
            <span className="qwerty-3">:</span>
              {"\n"}
              <span className="qwerty-6"> echo</span>
            <span className="qwerty-2"> "</span>
            <span className="qwerty-4">Mar</span>
            <span className="qwerty-2">";</span>
              {"\n"} 
              <span className="qwerty-10">  Break</span>
              <span className="qwerty-4">;</span>
              {"\n"} 
              <span className="qwerty">Case </span>
            <span className="qwerty-4">4</span>
            <span className="qwerty-3">:</span>
              {"\n"}
              <span className="qwerty-6"> echo</span>
            <span className="qwerty-2"> "</span>
            <span className="qwerty-4">Apr</span>
            <span className="qwerty-2">";</span>
              {"\n"} 
              <span className="qwerty-10">  Break</span>
              <span className="qwerty-4">;</span>
              {"\n"} 
              <span className="qwerty-3"> Default </span>
              <span className="qwerty-4">:</span>
              {"\n"} 
              <span className="qwerty-6"> echo</span>
            <span className="qwerty-9"> "</span>
            <span className="qwerty-4">Enter Correct Value</span>
            <span className="qwerty-9">";</span>
            <span className="qwerty-9"> // </span>
            <span className="qwerty-9">(</span>
            <span className="qwerty-10">If you type incorrect Month no so Default data show</span>
            <span className="qwerty-9">)</span>
              {"\n"} 
              <span className="qwerty-10">  Break</span>
              <span className="qwerty-4">;</span>
              {"\n"} 
              <span className="qwerty-3">&#125;</span>
              {"\n"} 
              <span className="qwerty-2"> ?</span>
              <span className="qwerty-4">&#62;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>  

       <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
                <span className="qwerty-4"> Apr</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>  



<h2 className="headings">Q-Write a program without input use a switch case in Php?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-4">&#60;</span>
            <span className="qwerty-2">?</span>
            <span className="qwerty-6">php</span>
            {"\n"}
            <span className="qwerty">$</span>
            <span className="qwerty-7">i </span>
            <span className="qwerty-4">=</span>
            <span className="qwerty-5"> 280</span>
            <span className="qwerty-4">;</span>
              {"\n"}
              <span className="qwerty-6"> Switch</span>
            <span className="qwerty-2"> (</span>
              <span className="qwerty">$</span>
            <span className="qwerty-7">i</span>
            <span className="qwerty-2">)</span>
              {"\n"}
            <span className="qwerty-3">&#123;</span>
              {"\n"} 
            <span className="qwerty">Case </span>
            <span className="qwerty-5">180</span>
            <span className="qwerty-3">:</span>
              {"\n"}
              <span className="qwerty-7"> echo </span>
              <span className="qwerty-2"> "</span>
            <span className="qwerty-4">My value is </span>
            <span className="qwerty-5">180</span>
            <span className="qwerty-2">";</span>
              {"\n"} 
              <span className="qwerty-10">  Break</span>
              <span className="qwerty-4">;</span>
              {"\n"} 
            <span className="qwerty">Case </span>
            <span className="qwerty-5">280</span>
            <span className="qwerty-3">:</span>
              {"\n"}
              <span className="qwerty-7"> echo</span>
            <span className="qwerty-2"> "</span>
            <span className="qwerty-4">My value is </span>
            <span className="qwerty-5">280</span>
            <span className="qwerty-2">";</span>
              {"\n"} 
              <span className="qwerty-10">  Break</span>
              <span className="qwerty-4">;</span>
              {"\n"}  
            <span className="qwerty">Case </span>
            <span className="qwerty-5">380</span>
            <span className="qwerty-3">:</span>
              {"\n"}
              <span className="qwerty-7"> echo</span>
            <span className="qwerty-2"> "</span>
            <span className="qwerty-4">My value is </span>
            <span className="qwerty-5">380</span>
            <span className="qwerty-2">";</span>
              {"\n"} 
              <span className="qwerty-10">  Break</span>
              <span className="qwerty-4">;</span>
              {"\n"} 
              <span className="qwerty">Case </span>
            <span className="qwerty-5">480</span>
            <span className="qwerty-3">:</span>
              {"\n"}
              <span className="qwerty-7"> echo</span>
            <span className="qwerty-2"> "</span>
            <span className="qwerty-4">My value is </span>
            <span className="qwerty-5">480</span>
            <span className="qwerty-2">";</span>
              {"\n"} 
              <span className="qwerty-10">  Break</span>
              <span className="qwerty-4">;</span>
              {"\n"} 
              <span className="qwerty-3"> Default </span>
              <span className="qwerty-4">:</span>
              {"\n"} 
              <span className="qwerty-7"> echo</span>
            <span className="qwerty-9"> "</span>
            <span className="qwerty-4">Enter Correct Value</span>
            <span className="qwerty-9">";</span>
              {"\n"} 
              <span className="qwerty-10">  Break</span>
              <span className="qwerty-4">;</span>
              {"\n"} 
              <span className="qwerty-3">&#125;</span>
              {"\n"} 
              <span className="qwerty-2"> ?</span>
              <span className="qwerty-4">&#62;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>  

       <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
                <span className="qwerty-4"> My value is </span>
            <span className="qwerty-5">280</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>  

<h2 className="mt-4 mh2">Character switch case in Php:</h2>


<h2 className="headings">Q-Write a program character switch case in Switch Php?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-4">&#60;</span>
            <span className="qwerty-2">?</span>
            <span className="qwerty-6">php</span>
            {"\n"}
            <span className="qwerty">$</span>
            <span className="qwerty-7">i </span>
            <span className="qwerty-4">=</span>
            <span className="qwerty-5"> '</span>
            <span className="qwerty-7">d</span>
            <span className="qwerty-5">';</span>
              {"\n"}
              <span className="qwerty-6"> Switch</span>
            <span className="qwerty-2"> (</span>
              <span className="qwerty">$</span>
            <span className="qwerty-7">i</span>
            <span className="qwerty-2">)</span>
              {"\n"}
            <span className="qwerty-3">&#123;</span>
              {"\n"} 
            <span className="qwerty">Case </span>
            <span className="qwerty-5">'b'</span>
            <span className="qwerty-3">:</span>
              {"\n"}
              <span className="qwerty-7"> echo </span>
              <span className="qwerty-2"> "</span>
            <span className="qwerty-4">value is </span>
            <span className="qwerty-5">b</span>
            <span className="qwerty-2">";</span>
              {"\n"} 
              <span className="qwerty-6">  Break</span>
              <span className="qwerty-4">;</span>
              {"\n"} 
            <span className="qwerty">Case </span>
            <span className="qwerty-5">'d'</span>
            <span className="qwerty-3">:</span>
              {"\n"}
              <span className="qwerty-7"> echo</span>
            <span className="qwerty-2"> "</span>
            <span className="qwerty-4">value is </span>
            <span className="qwerty-5">d</span>
            <span className="qwerty-2">";</span>
              {"\n"} 
              <span className="qwerty-6">  Break</span>
              <span className="qwerty-4">;</span>
              {"\n"}  
            <span className="qwerty">Case </span>
            <span className="qwerty-5">'f'</span>
            <span className="qwerty-3">:</span>
              {"\n"}
              <span className="qwerty-7"> echo</span>
            <span className="qwerty-2"> "</span>
            <span className="qwerty-4"> value is </span>
            <span className="qwerty-5">f</span>
            <span className="qwerty-2">";</span>
              {"\n"} 
              <span className="qwerty-6">  Break</span>
              <span className="qwerty-4">;</span>
              {"\n"} 
              <span className="qwerty">Case </span>
            <span className="qwerty-5">'h'</span>
            <span className="qwerty-3">:</span>
              {"\n"}
              <span className="qwerty-7"> echo</span>
            <span className="qwerty-2"> "</span>
            <span className="qwerty-4"> value is </span>
            <span className="qwerty-5">h</span>
            <span className="qwerty-2">";</span>
              {"\n"} 
              <span className="qwerty-6">  Break</span>
              <span className="qwerty-4">;</span>
              {"\n"} 
              <span className="qwerty-3"> Default </span>
              <span className="qwerty-4">:</span>
              {"\n"} 
              <span className="qwerty-7"> echo</span>
            <span className="qwerty-9"> "</span>
            <span className="qwerty-4">Enter Correct Value</span>
            <span className="qwerty-9">";</span>
              {"\n"} 
              <span className="qwerty-5">  Break</span>
              <span className="qwerty-4">;</span>
              {"\n"} 
              <span className="qwerty-3">&#125;</span>
              {"\n"} 
              <span className="qwerty-2"> ?</span>
              <span className="qwerty-4">&#62;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>  

       <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
                <span className="qwerty-4"> value is</span>
            <span className="qwerty-5"> d</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>



<h2 className="headings">Q-Write a program to check a no b/w Two no switch case in Php?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
            <span className="qwerty-4">&#60;</span>
            <span className="qwerty-2">?</span>
            <span className="qwerty-6">php</span>
            {"\n"}
            <span className="qwerty">$</span>
            <span className="qwerty-10">date </span>
            <span className="qwerty-4">= </span>
            <span className="qwerty-7">8</span>
            <span className="qwerty-4">;</span>
              {"\n"}
              <span className="qwerty-6"> Switch</span>
            <span className="qwerty-2"> (</span>
            <span className="qwerty-7">true</span>
            <span className="qwerty-2">)</span>
              {"\n"}
            <span className="qwerty-3">&#123;</span>
              {"\n"} 
            <span className="qwerty">Case </span>
            <span className="qwerty-5">(</span>
              <span className="qwerty">$</span>
            <span className="qwerty-10">date </span>
            <span className="qwerty-3">&#62;</span>
              <span className="qwerty-7">= </span>
              <span className="qwerty-2"> 10</span>
            <span className="qwerty-4"> && </span>
            <span className="qwerty">$</span>
            <span className="qwerty-10">date </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-7">= </span>
            <span className="qwerty-2">20</span>
            <span className="qwerty-5">):</span>
              {"\n"} 
              <span className="qwerty-7"> Echo</span>
            <span className="qwerty-2"> "</span>
            <span className="qwerty-4">your date is correct</span>
            <span className="qwerty-2">";</span>
              {"\n"} 
              <span className="qwerty-10">  Break</span>
              <span className="qwerty-4">;</span>
              {"\n"} 
              <span className="qwerty">Case </span>
            <span className="qwerty-5">(</span>
              <span className="qwerty">$</span>
            <span className="qwerty-10">date </span>
            <span className="qwerty-3">&#62;</span>
              <span className="qwerty-7">= </span>
              <span className="qwerty-2"> 21</span>
            <span className="qwerty-4"> && </span>
            <span className="qwerty">$</span>
            <span className="qwerty-10">date </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-7">= </span>
            <span className="qwerty-2">30</span>
            <span className="qwerty-5">):</span>
              {"\n"} 
              <span className="qwerty-7"> Echo</span>
            <span className="qwerty-2"> "</span>
            <span className="qwerty-4">your date is incorrect</span>
            <span className="qwerty-2">";</span>
              {"\n"} 
              <span className="qwerty-10">  Break</span>
              <span className="qwerty-4">;</span>
              {"\n"} 
              <span className="qwerty-3"> Default </span>
              <span className="qwerty-4">:</span>
              {"\n"} 
              <span className="qwerty-7"> Echo</span>
            <span className="qwerty-9"> "</span>
            <span className="qwerty-4">Please enter a valid </span>
            <span className="qwerty-10">date</span>
            <span className="qwerty-9">";</span>
              {"\n"} 
              <span className="qwerty-10">  Break</span>
              <span className="qwerty-4">;</span>
              {"\n"} 
              <span className="qwerty-3">&#125;</span>
              {"\n"} 
              <span className="qwerty-2"> ?</span>
              <span className="qwerty-4">&#62;</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>  

       <h2 className="headings">Output</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}
                <span className="qwerty-4"> Please enter a valid </span>
            <span className="qwerty-10">date</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>  

  <h1 className="mt-5">  </h1>
   
  <div className="back">
        <a href="/php-if-else-if">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-looping-statement">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csswitch;